import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import { useState } from "react";

const VerificationStep = ({
  commonContainerStyle,
  selectedFile,
  handleFileChange,
  handleRemoveFile,
  isDeclarationChecked,
  setIsDeclarationChecked,
  handleBack,
  handleSubmit,
}) => {
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState();
  const checkCategory = async () => {
    setSubmitting(true);
    const response = await apiClient.get("/counselling/buyStatus");
    // console.log(response);
    if (response?.data?.success) {
      if (response.data.boughtStatus === false) {
        navigate("/counselling-checkout");
      } else {
        navigate("/areaType-info");
      }
    } else {
      alert("Some error occured");
    }
    setSubmitting(false);
  };
  const handleClick = () => {
    if (isDeclarationChecked) {
      checkCategory();
    } else {
      alert("Please check the declaration");
    }
  };

  return (
    <div style={commonContainerStyle}>
      <Box
        sx={{
          padding: {
            md: "50px 50px 0px 50px",
            sm: "20px",
          },
        }}
      >
        <Grid container spacing={3}>
          {/* Title */}
          {/* <Grid item xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "black", fontWeight: "bold", mb: 2 }}
            >
              Verification
            </Typography>
          </Grid> */}

          {/* ID Upload */}
          {/* <Grid item xs={12} md={6}>
            <Typography sx={{ color: "black", mb: 1 }}>
              Upload ID Proof (Aadhar)*
            </Typography>

            <Button
              variant="outlined"
              component="label"
              sx={{
                backgroundColor: "white",
                color: "black",
                textTransform: "none",
                borderRadius: "4px",
                padding: "10px 20px",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                  borderColor: "#888",
                },
              }}
            >
              Choose File
              <input
                hidden
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileChange}
              />
            </Button> */}

          {/* File name + remove */}
          {/* {selectedFile && (
              <Box mt={2} display="flex" alignItems="center" gap={2}>
                <Typography variant="body2" sx={{ color: "black" }}>
                  {selectedFile.name}
                </Typography>

                <Button
                  size="small"
                  variant="text"
                  onClick={handleRemoveFile}
                  sx={{
                    textTransform: "none",
                    color: "#d32f2f",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Remove
                </Button>
              </Box>
            )}
          </Grid> */}

          {/* Declaration */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ color: "black", mt: 4, mb: 2 }}>
              Declaration
            </Typography>

            <FormControlLabel
              sx={{ backgroundColor: "#fff", p: 3, borderRadius: "20px" }}
              control={
                <Checkbox
                  id="declaration"
                  sx={{
                    color: "black",
                    "&.Mui-checked": { color: "black" },
                  }}
                  checked={isDeclarationChecked}
                  onChange={() =>
                    setIsDeclarationChecked(!isDeclarationChecked)
                  }
                />
              }
              label={
                <Typography sx={{ color: "black", ml: 1 }}>
                  I hereby declare that the information provided in this
                  admission form is true, complete, and accurate to the best of
                  my knowledge and belief. I understand that any false or
                  misleading information given in this form may result in the
                  cancellation of admission. I agree to abide by the rules and
                  regulations of the YAPASSIO and ensure that my child adheres
                  to the same. I consent to the YAPASSIO using the provided
                  information for administrative and educational purposes in
                  accordance with the YAPASSIO's privacy policy.
                </Typography>
              }
            />
          </Grid>

          {/* Navigation Buttons */}
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={4}
          >
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{
                color: "black",
                borderColor: "black",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  borderColor: "#888",
                },
              }}
            >
              Go Back
            </Button>

            <Box display="flex" alignItems="center" gap={2}>
              <Typography sx={{ color: "red", fontWeight: 500 }}>
                * Important
              </Typography>

              <Button
                type="submit"
                variant="contained"
                onClick={handleClick}
                disabled={isSubmitting}
                sx={{
                  backgroundColor: "#2C2C2C",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#444",
                  },
                }}
              >
                {isSubmitting ? "Loading..." : "Submit"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default VerificationStep;
